module.exports = __webpack_public_path__ + "media/images/shapes/angles/angle-bottom-left-0aeab48e683dc8bbe365d1feba4fef7e.svg";